import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "64",
  height: "64",
  viewBox: "0 0 64 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M59.2724 10.1816C54.6939 10.1816 50.9691 6.45675 50.9691 1.8785V0H13.0307V1.8785C13.0307 6.457 9.30587 10.1816 4.72762 10.1816H2.84912V22.6739C2.84912 31.6508 5.55325 40.2946 10.6695 47.6709C15.7857 55.047 22.9341 60.6085 31.3419 63.7537L32 64L32.6582 63.7537C41.0661 60.6085 48.2145 55.0471 53.3305 47.6709C58.4467 40.2946 61.1509 31.6508 61.1509 22.6739V10.1816H59.2724ZM57.394 22.6739H57.3939C57.3939 30.8819 54.9212 38.7851 50.2432 45.5295C45.6996 52.0805 39.4024 57.0661 31.9999 59.982C24.5975 57.066 18.3001 52.0805 13.7565 45.5295C9.07862 38.7852 6.60612 30.8819 6.60612 22.6739V13.7926C11.7549 12.9839 15.833 8.90575 16.6417 3.757H47.3584C48.167 8.90575 52.2451 12.9839 57.394 13.7926V22.6739Z",
      fill: "#002565"
    }, null, -1),
    _createElementVNode("path", {
      d: "M40.3822 17.6483L27.9476 30.0831L23.6175 25.7529L15.6477 33.7228L27.9476 46.0227L48.352 25.6182L40.3822 17.6483ZM20.961 33.7231L23.6176 31.0664L27.9477 35.3966L40.3823 22.9618L43.039 25.6184L27.9477 40.7097L20.961 33.7231Z",
      fill: "#002565"
    }, null, -1)
  ])))
}
export default { render: render }